function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomUpgradeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 16.535a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.168 5.323c-.147.206-.2.485-.196.657V29.086h-2V6.02a3.17 3.17 0 01.567-1.856c.492-.691 1.31-1.179 2.457-1.179h11.009v2H6.995c-.515 0-.718.187-.827.34z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 30.016H1.996v-2H28v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.05 29v-8.41h2V29h-2zM20.114 18.434h6.592v-2h-6.592v2zM30 9.56h-3.295v5.858h-6.59V9.561h-3.296l5.993-7.295A.817.817 0 0123.418 2a.82.82 0 01.608.268L30 9.56zm-4.224-2l-2.36-2.88-2.366 2.88h1.064v5.858h2.59V7.561h1.072z",
    fill: props.color
  }));
}

export default SvgIconRoomUpgradeFilled;